<div class="chat-dialog-container" [ngClass]="{'dark-theme': isDark, 'minimized': isMinimized}"
     cdkDrag cdkDragRootElement=".cdk-overlay-pane">

    <!-- Header -->
    <div class="chat-header" cdkDragHandle>
        <div class="chat-header-left">
            <mat-icon class="chat-icon">smart_toy</mat-icon>
            <span class="chat-title">Asistente de condiciones</span>
        </div>
        <div class="chat-header-right">
            <button mat-icon-button (click)="resetConversacion()" title="Nueva conversación" class="header-btn" [style.display]="isMinimized ? 'none' : ''">
                <mat-icon>restart_alt</mat-icon>
            </button>
            <button mat-icon-button (click)="toggleMinimize()" [title]="isMinimized ? 'Restaurar' : 'Minimizar'" class="header-btn">
                <mat-icon>{{ isMinimized ? 'open_in_full' : 'remove' }}</mat-icon>
            </button>
            <button mat-icon-button (click)="cancelar()" class="header-btn">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <!-- Condición seleccionada (barra superior) -->
    <!-- En modo guardar (StrategyFactory) la selección va en la barra inferior -->
    <div class="condicion-preview" *ngIf="condicionSeleccionada && !onSaveCallback">
        <mat-icon class="preview-icon">check_circle</mat-icon>
        <span class="preview-text" title="{{ condicionSeleccionada }}">{{ condicionSeleccionada }}</span>
        <button mat-raised-button class="btn-aplicar-preview" (click)="aplicarCondicionActual()" [title]="data.onCondicionChange ? 'Aplicar al formulario' : 'Guardar condición'">
            <mat-icon>{{ data.onCondicionChange ? 'add_circle' : 'save' }}</mat-icon>
            {{ data.onCondicionChange ? 'Aplicar' : 'Guardar' }}
        </button>
        <button mat-icon-button class="btn-cerrar-preview" (click)="cancelar()" title="Cerrar asistente">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Mensajes del chat -->
    <div class="chat-messages">
        <div *ngFor="let m of mensajes" class="mensaje-wrapper" [ngClass]="m.role">

            <!-- Burbuja de texto -->
            <div class="burbuja">
                <pre class="msg-text" *ngIf="!m.textoPlegado || m.verTexto">{{ m.text }}</pre>
                <div class="texto-plegado" *ngIf="m.textoPlegado">
                    <span>{{ totalCondiciones(m) }} condiciones</span>
                    <button type="button" class="link-btn" (click)="m.verTexto = !m.verTexto">
                        {{ m.verTexto ? 'Ocultar texto original' : 'Ver texto original' }}
                    </button>
                </div>

                <!-- Chips de sugerencias -->
                <div class="sugerencias-row" *ngIf="m.sugerencias && m.sugerencias.length > 0 && (!m.grupos || tieneVariasAplicables(m))">
                    <button
                        *ngIf="tieneVariasAplicables(m)"
                        class="chip-btn chip-todas"
                        [class.chip-seleccionado]="todasSeleccionadas(m)"
                        (click)="toggleTodas(m)"
                        [title]="todasSeleccionadas(m) ? 'Desmarcar todas' : 'Marcar todas para guardar'">
                        <mat-icon class="chip-icon">{{ todasSeleccionadas(m) ? 'check_box' : 'select_all' }}</mat-icon>
                        {{ todasSeleccionadas(m) ? 'Quitar todas' : 'Agregar todas' }}
                    </button>
                    <ng-container *ngIf="!m.grupos">
                        <ng-container *ngFor="let s of m.sugerencias">
                            <ng-container *ngTemplateOutlet="chip; context: { $implicit: s }"></ng-container>
                        </ng-container>
                    </ng-container>
                </div>

                <!-- Lista clasificada: un subtítulo por categoría del texto con sus chips debajo -->
                <div class="grupo-chips" *ngFor="let g of m.grupos">
                    <div class="grupo-titulo" *ngIf="g.titulo">{{ g.titulo }}</div>
                    <div class="sugerencias-row">
                        <ng-container *ngFor="let s of g.sugerencias">
                            <ng-container *ngTemplateOutlet="chip; context: { $implicit: s }"></ng-container>
                        </ng-container>
                    </div>
                </div>

                <!-- Flujo de ideas: estado de la traducción y condiciones que el motor no puede ejecutar -->
                <div class="traduccion-estado" *ngIf="m.traduciendo">Traduciendo a condiciones del motor…</div>
                <div class="traduccion-estado" *ngIf="m.errorTraduccion">
                    No se pudieron traducir las condiciones. Pídelas de nuevo o escribe una concreta.
                </div>
                <div class="no-soportadas" *ngIf="m.noSoportadas && m.noSoportadas.length > 0">
                    <div class="no-soportadas-titulo">No ejecutables en el motor ({{ m.noSoportadas.length }})</div>
                    <div class="no-soportada" *ngFor="let n of m.noSoportadas" [title]="n.original">
                        <span class="ns-original">{{ n.original }}</span>
                        <span class="ns-motivo">{{ n.motivo }}</span>
                    </div>
                </div>
            </div>

        </div>

        <!-- Indicador de carga -->
        <div class="mensaje-wrapper assistant" *ngIf="loading">
            <div class="burbuja loading-burbuja">
                <span class="dot"></span><span class="dot"></span><span class="dot"></span>
            </div>
        </div>
    </div>

    <!-- Barra de selección: ocupa el lugar del input mientras haya condiciones marcadas -->
    <div class="seleccion-bar" *ngIf="mostrarBarraSeleccion">
        <div class="seleccion-panel" *ngIf="listaAbierta">
            <div class="seleccion-item" *ngFor="let c of condicionesSeleccionadas">
                <mat-icon class="preview-icon">check_circle</mat-icon>
                <span class="preview-text" title="{{ c }}">{{ c }}</span>
                <button mat-icon-button class="btn-cerrar-preview" (click)="quitarSeleccion(c)" title="Quitar">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="seleccion-item" *ngIf="combinadaPendiente">
                <mat-icon class="preview-icon">merge_type</mat-icon>
                <span class="preview-text" title="{{ condicionaguardar }}">{{ condicionaguardar }}</span>
                <button mat-icon-button class="btn-cerrar-preview" (click)="quitarCombinada()" title="Quitar">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <button class="seleccion-toggle" (click)="toggleLista()" [title]="listaAbierta ? 'Ocultar lista' : 'Ver lista'">
            <mat-icon class="chip-icon">check_box</mat-icon>
            {{ totalAGuardar }} seleccionada{{ totalAGuardar === 1 ? '' : 's' }}
            <mat-icon class="chip-icon">{{ listaAbierta ? 'expand_more' : 'expand_less' }}</mat-icon>
        </button>
        <span class="seleccion-spacer"></span>
        <button mat-icon-button class="btn-cerrar-preview" (click)="escribiendo = true" title="Escribir en el chat">
            <mat-icon>chat</mat-icon>
        </button>
        <button mat-icon-button class="btn-cerrar-preview" (click)="limpiarSeleccion()" title="Limpiar selección">
            <mat-icon>delete_sweep</mat-icon>
        </button>
        <button mat-raised-button class="btn-aplicar-preview" (click)="aplicarCondicionActual()" title="Guardar condiciones seleccionadas">
            <mat-icon>save</mat-icon>
            Guardar ({{ totalAGuardar }})
        </button>
    </div>

    <ng-template #chip let-s>
        <button
            class="chip-btn"
            [ngClass]="badgeClass(s.tipo)"
            [class.chip-seleccionado]="onSaveCallback && isSeleccionada(s.query)"
            (click)="accionarSugerencia(s)"
            [title]="s.query">
            <mat-icon class="chip-icon">{{ accionIcon(s.accion, s.query) }}</mat-icon>
            {{ s.etiqueta }}
        </button>
    </ng-template>

    <!-- Input -->
    <div class="chat-input-row" *ngIf="!mostrarBarraSeleccion">
        <button mat-icon-button *ngIf="onSaveCallback && totalAGuardar > 0" (click)="escribiendo = false"
            class="btn-volver-seleccion" title="Volver a las condiciones seleccionadas">
            <mat-icon>check_box</mat-icon>
            <span class="seleccion-badge">{{ totalAGuardar }}</span>
        </button>
        <!-- textarea: un <input> pierde los saltos de línea de lo que se pega de otra IA -->
        <textarea
            class="chat-input"
            rows="1"
            [(ngModel)]="inputText"
            placeholder="Pide condiciones o pega las de otra IA..."
            (keydown)="onKeydown($event)"
            [disabled]="loading"
            autofocus></textarea>
        <button mat-icon-button (click)="enviar()" [disabled]="loading || !inputText.trim()" class="btn-send">
            <mat-icon>send</mat-icon>
        </button>
    </div>

</div>
